import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-conf',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './conf.template.component.html',
  styleUrls: ['./conf.template.component.scss']
})
export class SkeletorConfTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}

